<template>
  <div class="draggable">
    <el-table
      :data="data"
      :height="height"
      :max-height="maxHeight"
      :header-cell-style="headerStyle"
      :cell-style="cellStyle"
      :row-class-name="rowClassName"
      :cell-class-name="cellClassName"
      :class="{ isMerge: mergeCols.length }"
      @selection-change="handleSelectionChange"
      @mouseenter.native="mouseenter"
      @mouseleave.native="mouseleave"
      @row-click="handleRowClick"
      row-key="id"
      v-loading="loading"
      v-bind="$attrs"
      ref="table"
    >
      <el-table-column type="selection" width="50" align="center" v-if="isSelected" />
      <el-table-column label="序号" type="index" width="50" align="center" v-if="isSort">
        <template slot-scope="scope">
          <!-- 有分页时-->
          <span v-if="queryParams">{{ (queryParams.pageNum - 1) * queryParams.pageSize + scope.$index + 1 }}</span>
          <!-- 无分页时 -->
          <span v-else>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <template v-for="(col, index) in columns">
        <!-- 操作列/自定义列 -->
        <slot v-if="col.slot" :name="col.slot"></slot>
        <!-- 普通列 -->
        <el-table-column
          v-else
          :key="index"
          :prop="col.prop"
          :label="col.label"
          :width="col.width"
          :formatter="col.formatter"
          :show-overflow-tooltip="true"
          align="center"
          @click="handleClick(col)"
        >
        </el-table-column>
      </template>
    </el-table>
  </div>
</template>

<script>
import Sortable from "sortablejs";
export default {
  name: "commonTable",
  computed: {},
  data() {
    return {
      currentIndex: 0,
      tableMergeIndex: [],
    };
  },
  props: {
    // 是否显示序号
    isSort: {
      type: Boolean,
      default: false,
    },
    // 是否加载显示
    loading: {
      type: Boolean,
      default: false,
    },
    // 表格高度
    height: {
      type: [String, Number],
    },
    // 最大高度
    maxHeight: {
      type: [String, Number],
    },
    //是否可以勾选
    isSelected: {
      type: Boolean,
      default: true,
    },
    // 表格内数据
    data: {
      type: Array,
      default: () => [],
    },
    // 表格内列的名称
    columns: {
      type: Array,
      default: () => [],
    },
    // 查询的参数
    queryParams: {
      type: Object,
      default: () => {},
    },
    // 表格头部样式
    headerStyle: {
      type: Object,
    },
    // 表格行样式
    rowClassName: {
      type: Function,
    },
    // 表格单元格样式
    cellClassName: {
      type: Function,
    },
    // 是否自动滚动
    isRoll: {
      type: Boolean,
      default: false,
    },
    isDraggable: {
      type: Boolean,
      default: false,
    },
    // 合并列项目
    mergeCols: {
      type: Array,
      default: () => [],
    },
  },
  computed: {},
  watch: {},
  mounted() {
    this.$nextTick(() => {
      this.mouseleave();
    });
  },
  beforeDestroy() {
    this.mouseenter();
  },
  methods: {
    cellStyle(data) {
      if (this.isDraggable) {
        return "cursor:move;";
      }
      // if (data) {
      //   return "cursor:pointer;";
      // }
    },
    autoRoll(stop) {
      if (!this.data.length) return;
      if (stop) {
        clearInterval(this.rolltimer);
        return;
      }
      const table = this.$refs.table;
      const bodyWrapper = table.bodyWrapper;
      // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果
      this.rolltimer = setInterval(() => {
        // 判断是否滚动到此元素,并高亮显示
        let index = parseInt(bodyWrapper.scrollTop / 20);
        table.setCurrentRow(this.data[index], true);
        if (this.currentIndex !== index) {
          //根据不同行做需要做的事情
          this.autoProcess(index);
        }
        // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
        if (bodyWrapper.clientHeight + Math.ceil(bodyWrapper.scrollTop) >= bodyWrapper.scrollHeight) {
          bodyWrapper.scrollTop = 0;
        } else {
          bodyWrapper.scrollTop++;
        }
      }, 5 * 10);
    },
    mouseenter() {
      this.isRoll && this.autoRoll(true);
    },
    mouseleave() {
      this.isRoll && this.autoRoll();
    },
    //列点击事件
    handleClick(col) {
      this.$emit("click", col);
    },
    // 勾选框变化时
    handleSelectionChange(selection) {
      this.$emit("select", selection);
    },
    // 点击某一行时触发
    handleRowClick(row) {
      this.$emit("rowClick", row);
    },
    autoProcess(index) {
      this.currentIndex = index;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/mixin.scss";
::v-deep .el-table__body-wrapper {
  @include scrollStyle;
}
::v-deep .isMerge.el-table tbody tr:hover > td {
  background-color: transparent !important;
}
</style>
